<div class="dialogContainer">
  @if (errorMessage()) {
    <div class="errorMessage">
      <pre>{{ errorMessage() }}</pre>
    </div>
  }
  <div class="content">
    <div class="inputs">
      <div class="listWrapper">
        <input #listFilter class="filterInput" type="text" placeholder="Filter" (keyup)="filter(listFilter.value)"/>
        <div class="selectionTableWrapper">
          @if (filteredHeaders) {
            <table class="reportTable">
              <thead>
                <tr>
                  <td class="headerCell tableCell" (click)="toggleMassSelection()">
                    <input type="checkbox" [checked]="allFilteredLinesSelected()"/>
                  </td>
                  <td class="headerCell tableCell">Description</td>
                  <td class="headerCell tableCell">Qty</td>
                </tr>
              </thead>
              @for (header of filteredHeaders; track header) {
                <tr (click)="toggleSelection(header)" [class.selected]="isSelected(header)">
                  <td class="tableCell">
                    <input type="checkbox" [checked]="isSelected(header)">
                  </td>
                  <td class="tableCell">{{ header.lineId + '_' + header.description }}</td>
                  <td class="tableCell">{{ header.quantity }}</td>
                </tr>
              }
            </table>
          }
        </div>
      </div>
      <div class="selectionsWrapper">
        <div>
          @for (selection of commonSelections(); track selection) {
            <div class="selectionRow">
              @if (selection.EntityType === 'List') {
                <div>
                  <label class="selectionLabel">{{ selection.Description || selection.Name }}:</label>
                  <select #selectionInput class="configurationInputField" [value]="selection.Value"
                    (change)="setListValue(selection.Name, selectionInput.value)">
                    @for (allowable of selection.Allowables; track allowable) {
                      <option
                        [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                        [selected]="selection.Value && selection.Value.toString() === allowable.Value"
                        [value]="allowable.Value">{{ allowable.Description }}
                      </option>
                    }
                  </select>
                </div>
              }
              @if (selection.EntityType === 'Boolean') {
                <div>
                  <label class="selectionLabel"></label>
                  <mat-checkbox #checkboxInput [value]="selection.Value"
                    (change)="setBooleanValue(selection.Name, checkboxInput.checked)">
                    {{ selection.Description || selection.Name }}
                  </mat-checkbox>
                </div>
              }
              @if (selection.EntityType === 'Numeric') {
                <div>
                  <label class="selectionLabel">{{ selection.Description || selection.Name }}:</label>
                  <input #numericInput class="configurationInputField" [value]="selection.Value"
                    (change)="setNumericValue(selection.Name, numericInput.value)"/>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    @if (!isBusy()) {
      <div class="buttonWrapper">
        <button class="inputButton" [disabled]="!selectedLines || selectedLines.length === 0" matButton="elevated"
          (click)="loadCommonSelections()">Load
        </button>
        <span class="spacer"></span>
        <button class="inputButton warn-button" matButton="elevated" (click)="close()">Cancel</button>
        <button [disabled]="noChangesMade()" class="inputButton primary-button" matButton="elevated" (click)="save()">Save</button>
      </div>
    }
    @if (isBusy()) {
      <div class="buttonWrapper">
        <span class="spacer"></span>
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
        <span class="spacer"></span>
      </div>
    }
  </div>
</div>
